export const top4TOS = [
  {
    industryName: "Fintech",
    cagr: 10,
    size: { india: 15, global: 100 },
    bigPlayers: ["Stripe", "Square", "Revolut"],
    color:"bg-red-400",
    bgColor:"bg-red-200",

  },
  {
    industryName: "Edtech",
    cagr: 15,
    size: { india: 30, global: 80 },
    bigPlayers: ["BYJU'S", "Unacademy", "Coursera"],
    color:"bg-orange-400",
    bgColor:"bg-orange-200",
  },
  {
    industryName: "Healthtech",
    cagr: 17,
    size: { india: 13, global: 90 },
    bigPlayers: ["M2GEN", "DearDoc", "connectRN"],
    color:"bg-fuchsia-400",
    bgColor:"bg-fuchsia-200",
  },
  {
    industryName: "Agritech",
    cagr: 10,
    size: { india: 19, global: 110 },
    bigPlayers: ["AVPL", "Absolute", "AgNext"],
    color:"bg-indigo-400",
    bgColor:"bg-indigo-200",
  },
];
